import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

@Component
export default class CanRedirectAfterIpSettingsChange extends Vue {
  @Action("device/readName") readDeviceName!: ReadDeviceName;

  @Getter("device/ipSettings") deviceIpSettings!: IpSettings;
  @Getter("device/information") deviceInformation!: DeviceInformation;
  @Getter("device/mdns") mdns!: Mdns;

  maybeRedirectAfterIpSettingsChange(new_ip: string, force: boolean = false) {
    if (!this.deviceIpSettings || !this.deviceIpSettings.ip_address) {
      return;
    }

    if (["local", "development"].includes(process.env.VUE_APP_ENV)) {
      return;
    }

    if (!new_ip || (!force && this.deviceIpSettings.ip_address === new_ip)) {
      return;
    }

    setTimeout(() => { this.pollName(`//${new_ip}`); }, 1500);
  }

  pollName(new_ip: string = "/") {
    let redirect = new_ip;
    if (this.deviceInformation && this.deviceInformation.serial &&
            (!this.mdns || this.mdns.enabled)) {
        // Don't use serial.local if mdns is disabled
        redirect = `//${this.deviceInformation.serial}.local`;
    }

    let host = redirect != "/" ? redirect : undefined;

    this.readDeviceName({ skipStore: true, timeout: 80, host: host })
      .then(() => {
        window.location.replace(redirect);
      })
      .catch(() => {
        setTimeout(() => {
          this.pollName(new_ip);
        }, 6000);
      });
  }
}
